<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <loading-spinner v-if="isLoading"></loading-spinner>
                <paginated-table v-else :data="payments" :columns="tableColumns" :title="$t('title.payment_history')"
                    @updatePagination="updatePagination"></paginated-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PaginatedTable from '@/components/Tables/PaginatedTable.vue';
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';

import { getPaymentHistoryColumns } from "@/views/PaymentView/columns";
import { accountApi } from '@/api/api';

export default {
    name: "MemberPaymentHistory",
    components: {
        PaginatedTable,
        LoadingSpinner,
    },
    data() {
        return {
            tableColumns: getPaymentHistoryColumns({}),
            isLoading: false,
            payments: {
                page_info: {
                    page: 1,
                    size: 5,
                    total_elements: 1,
                    total_pages: 1,
                },
                elements: [],
            },
        }
    },

    methods: {
        async fetchPayments(size, page) {
            this.isLoading = true;

            try {
                const params = { size, page };
                const response = await accountApi.getPaymentsByMember(params);

                if (response && response.status === 200) {
                    this.payments = response.data.response;
                } else {
                    this.notifyVue({ message: this.$t('alert.failed_request'), style: "danger" });
                    this.$router.push({ name: "dashboard" });
                }
            } catch (error) {
                this.notifyVue({ message: this.$t('alert.failed_request'), style: "danger" });
                this.$router.push({ name: "dashboard" });
            } finally {
                this.isLoading = false;
            }
        },

        /**
         * Pagination 타입 명세
         * @typedef {Object} Pagination
         * @property {string} page - 페이지
         * @property {string} size - 사이즈
         * @property {string} total_elements - 전체 데이터 수 
         * @property {string} total_pages - 전체 페이지 수
         */

        /** 
         * 페이지네이션 업데이트 메서드
         *  
         * @description: 페이징 정보가 변경되면 하위 컴포넌트에서 정보를 받아 업데이트 및 API 요청
         * @params {Pagination} pagination
         */
        updatePagination(pagination) {
            this.payments.page_info.size = pagination.size;
            this.payments.page_info.page = pagination.page;

            this.fetchPayments(this.payments.page_info.size, this.payments.page_info.page);
        },

        /* ****************************************************************************************
         * 알럿
         * ****************************************************************************************/
        notifyVue({
            vertical = "top",
            horizontal = "right",
            message = "",
            style = "primary",
            icon = "priority_high",
        } = {}) {
            this.$notify({
                timeout: 8000,
                message: message,
                icon: icon,
                type: style,
                horizontalAlign: horizontal,
                verticalAlign: vertical,
            });
        }
    },
    mounted() {
        this.fetchPayments(this.payments.page_info.size, this.payments.page_info.page);
    }
}
</script>
<style></style>